import type { OperationalErrorOptions } from "./operational";
import { OperationalError } from "./operational";

class AuthenticationError extends OperationalError {
  constructor(options?: OperationalErrorOptions) {
    super(options);
    this.message = "You are not authenticated.";
  }
}

export { AuthenticationError };
